import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=170f3c12&scoped=true"
import script from "./NewCampaign.vue?vue&type=script&lang=js"
export * from "./NewCampaign.vue?vue&type=script&lang=js"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=170f3c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f3c12",
  null
  
)

export default component.exports